export enum WaterSupplySource {
  PHD = 1,
  Bore = 2,
  PHDAndBore = 3,
  Well = 4,
  Community = 5
}
